export const SUPPORTED_DSPS = ['Spotify', 'Apple', 'Amazon', 'Pandora'];
